import styled from "styled-components";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: hidden;
`;

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  width: 100%;
  padding: 20px;
  overflow: hidden;
`;

export const SearchAndButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 16px;
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
`;

export const FilterWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  flex: 1;
  overflow-x: auto;
  padding: 4px;
  min-height: 50px;
  
  &::-webkit-scrollbar {
    display: none;
  }
  
  scrollbar-width: none;
  -ms-overflow-style: none;

  & > * {
    min-height: 40px;
  }
`;

export const CustomSearchInput = styled.div`
  position: relative;
  width: 300px;
  min-width: 300px;
`;

export const InputField = styled.input`
  width: 100%;
  height: 40px;
  padding: 8px 12px 8px 40px;
  border: 1px solid ${props => props.theme.colors.dividerGray};
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  color: ${props => props.theme.colors.darkCharcoal};
  background-color: ${props => props.theme.colors.white};
  transition: border-color 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${props => props.theme.colors.celticBlue};
  }

  &::placeholder {
    color: ${props => props.theme.colors.placeholderText};
  }
`;

export const SearchIcon = styled.div`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.colors.grey};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  button:nth-child(1), button:nth-child(2) {
    padding-inline: 15px;
  }
  button:nth-child(3) {
    padding-inline: 10px;
  }
`;

export const TableWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;

  .MuiPaper-root {
    display: flex;
    flex-direction: column;
    height: 100%;
    box-shadow: none;
  }

  .MuiTableContainer-root {
    flex: 1;
    overflow: auto;
  }
`;

export const BreadCrumbContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-content: stretch;
  align-items: center;
  background: ${props => props.theme.colors.backgroundFafafa};
  padding: ${props => props.theme.containerPadding.small} ${props => props.theme.containerPadding.large};
  border: 1px solid ${props => props.theme.colors.breadcrumbBorder};
  overflow: hidden;
  max-height: 1.75rem;
  font-size: 0.625em;
  font-weight: bold;

  a {
    font-size: 0.625em;
    font-weight: bold;
  }
`;

export const MobileHiddenRoundedButton = styled.div`
  display: inline-block;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const StatusWrapperContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const StatusWrapper = styled.div`
  padding-block: 2px;
  border-radius: 10px;
  text-align: center;
  font-size: 12px;
  width: 120px;
  
  &.active {
    background-color: ${props => props.theme.status.active.background};
    color: ${props => props.theme.status.active.text};
    text-transform: capitalize;
    font-weight: 600;
  }

  &.inactive {
    background-color: ${props => props.theme.colors.errorLight};
    color: ${props => props.theme.colors.davysGrey};
    text-transform: capitalize;
    font-weight: 600;
  }
`;

export const AvatarNameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const TruncatedText = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  line-height: 1.2;
`;

export const SharedAgentsBadge = styled.div`
  display: inline-flex;
  padding: 4px 8px;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  border-radius: 100px;
  background: rgba(33, 115, 255, 0.20);
  
  color: ${props => props.theme.colors.celticBlue};
  font-family: 'Inter';
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;
  